import { GET_CONTEST_LIST_FAIL, GET_CONTEST_LIST_REQUEST, GET_CONTEST_LIST_SUCCESS } from "../../Constants/OrganizationConstant"


const initialStateAdmin = {
    loading_change_password: false,
    status_change_password: false,
    user_login_data: null,
    login_loading: false,
    login_status: null,
    logout_status: false,
    error_change_password: null,
};


const initialStateDefault = {
    status: false,
    data: null,
    loading: true,
    error: null,
}


export const ContestListData = (state = initialStateDefault, action: any) => {
    try {
  
        if (action.type === GET_CONTEST_LIST_REQUEST) {
            return {
              ...state,
              loading: true,
            };
          }
      
          if (action.type === GET_CONTEST_LIST_SUCCESS) {
            return {
              ...state,
              status: true,
              loading: false,
              data: action.data,
            };
          }
          if (action.type === GET_CONTEST_LIST_FAIL) {
            return {
              ...state,
              status: false,
              loading: false,
              data: action.data,
            };
          }
    } catch (error) {

    }
    return state;
}









